// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InlineEditItem_item__6MMIc {
    font-size: 14px;
    padding-left: 6px;
    padding-right: 6px;
    color: var(--color-101);
    text-align: center;
}

.InlineEditItem_item__6MMIc:hover {
    cursor: pointer;
    background: var(--color-203);
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/InlineEdit/InlineEditItem.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC","sourcesContent":[".item {\n    font-size: 14px;\n    padding-left: 6px;\n    padding-right: 6px;\n    color: var(--color-101);\n    text-align: center;\n}\n\n.item:hover {\n    cursor: pointer;\n    background: var(--color-203);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `InlineEditItem_item__6MMIc`
};
export default ___CSS_LOADER_EXPORT___;
